import React, { useEffect, useState } from "react";
import { useList } from "@/lib/hooks";
import { Panel } from "@/components/common";
import { fmtDur, toneOf } from "@/context/BreakContext";

const COLS = [["on_break", "On Break", "bg-amber-500"], ["active", "Active", "bg-emerald-500"], ["offline", "Offline", "bg-slate-300"]];

export function TeamStatusBoard() {
  const { data: rows = [] } = useList("team-status", "/team/status", { refetchInterval: 15000 });
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const id = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(id); }, []);
  return (
    <div className="grid md:grid-cols-3 gap-3" data-testid="team-status-board">
      {COLS.map(([k, label, dot]) => {
        const list = rows.filter((r) => r.status === k);
        return (
          <Panel key={k} className="p-4">
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em] text-slate-500 mb-3"><span className={`w-2.5 h-2.5 rounded-full ${dot} ${k === "on_break" ? "animate-pulse" : ""}`} />{label}<span className="ml-auto font-mono text-slate-900" data-testid={`board-count-${k}`}>{list.length}</span></p>
            <div className="space-y-1.5">
              {list.length === 0 ? <p className="text-xs text-slate-400">Nobody</p> : list.map((m) => {
                const secs = m.break ? (now - new Date(m.break.started_at).getTime()) / 1000 : 0;
                const over = m.break?.limit_min && secs > m.break.limit_min * 60;
                return (
                  <div key={m.id} className="flex items-center justify-between text-sm" data-testid={`board-member-${m.id}`}>
                    <span className="font-semibold text-slate-800 truncate">{m.name}<span className="text-[11px] font-normal text-slate-400 capitalize ml-1.5">{m.role}</span></span>
                    {m.break && <span className={`font-mono text-xs ${over ? "text-red-600 font-bold" : ""}`} style={over ? undefined : { color: toneOf(m.break.type) }}>{m.break.type.split(" ")[0]} · {fmtDur(secs)}</span>}
                  </div>
                );
              })}
            </div>
          </Panel>
        );
      })}
    </div>
  );
}
